var map = {
	"./web-p2-f1.svg": "fdf4",
	"./web-p2-f2.svg": "a84a",
	"./web-p2-f3.svg": "4005",
	"./web-p2-f4.svg": "4727",
	"./web-p2-f5.svg": "add7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4de1";